import {useState} from 'react';
import {SoopButtonIcon, SoopCheckbox} from '@soop-ui/soop-ui';
import {BottomBannerContentProps} from '../../type';
import styles from './FloatingBannerContent.module.scss';

const FloatingBannerContent = ({
  bannerName,
  imagePath,
  link,
  handleLinkClick,
  handleClose,
  handleHide,
  target,
}: BottomBannerContentProps) => {
  const [isDontShowAgain, setIsDontShowAgain] = useState(false);
  const handleChecked = (newChecked: boolean) => {
    setIsDontShowAgain(newChecked);
  };
  const onCloseClicked = () => {
    if (isDontShowAgain) {
      handleHide();
    } else {
      handleClose();
    }
  };

  return (
    <div className={styles.wrapper}>
      <a
        href={link}
        target={target === 'Y' ? '_blank' : '_self'}
        onClick={handleLinkClick}>
        <img src={imagePath} alt={bannerName} className={styles.image} />
      </a>

      <SoopButtonIcon
        iconName='icoCloseStrong'
        onClick={onCloseClicked}
        size={40}
        variant='clearPrimary'
        className={styles.close}>
        close
      </SoopButtonIcon>

      <div className={styles.dontShowAgain}>
        <SoopCheckbox
          color='primary'
          id='checkbox'
          label='다시 보지 않기'
          checked={isDontShowAgain}
          onChange={handleChecked}
          shape='default'
          size='md'
          className={styles.checkbox}
        />
      </div>
    </div>
  );
};

export default FloatingBannerContent;
